@if (
    formElement?.elementType === FORM_ELEMENT_TYPE.Field &&
    (formElement?.fieldType === FormFieldType.DateRange ||
        formElement?.fieldType === FormFieldType.DateTimeRange)
) {
    <ng-container [formGroup]="$any(controlContainer?.control)">
        @if (hideEnd !== undefined) {
            <wdx-form-field
                [label]="formElement?.label | translateTokenisedString"
                [guidanceText]="
                    formElement?.guidanceText | translateTokenisedString
                "
                [isSensitive]="formElement?.isSensitive ?? undefined"
                [isRequired]="formElement?.isRequired ?? undefined"
                [validationErrorMessage]="
                    formControl?.touched
                        ? (formControl?.errors ||
                              groupControl?.controls?.['start']?.errors ||
                              groupControl?.controls?.['end']?.errors
                          | validationErrorMessage)
                        : ''
                "
                [warningMessage]="warningText"
            >
                @if (
                    formElement?.fieldType === FormFieldType.DateRange
                        ? 'date'
                        : 'datetime-local';
                    as type
                ) {
                    <div
                        [class.grid]="!hideEnd"
                        [wdxInputDateRange]="{ hideEnd }"
                        [formGroupName]="$any(formElement?.name)"
                    >
                        <div
                            class="input-date"
                            ngClass="hideEnd ? '' : 'g-col-12 g-col-sm-6'"
                        >
                            <div class="input-wrapper">
                                <div class="input-wrapper__content ms-0">
                                    <input
                                        wdxInputText
                                        wdxInputDate
                                        [class.is-invalid]="
                                            formControl?.touched &&
                                            formControl?.invalid
                                        "
                                        [attr.type]="type"
                                        formControlName="start"
                                        [attr.data-cy]="
                                            formElement?.fieldType ===
                                            FormFieldType.DateRange
                                                ? 'input-date-start'
                                                : 'input-datetime-start'
                                        "
                                        [attr.required]="formElement.isRequired"
                                        [wdxUtilsDisabled]="
                                            isDisabled ||
                                            PENDING_CHANGES_LOCK_FIELD.includes(
                                                $any(
                                                    formElement.pendingChange
                                                        ?.status
                                                )
                                            )
                                        "
                                        (blur)="dateBlurEvent('start')"
                                    />
                                </div>
                            </div>
                        </div>

                        @if (!hideEnd) {
                            <div class="input-date">
                                <div class="input-wrapper">
                                    <div class="input-wrapper__content ms-0">
                                        <input
                                            wdxInputText
                                            wdxInputDate
                                            [class.is-invalid]="
                                                formControl?.touched &&
                                                formControl?.invalid
                                            "
                                            [attr.type]="type"
                                            formControlName="end"
                                            [attr.data-cy]="
                                                formElement?.fieldType ===
                                                FormFieldType.DateRange
                                                    ? 'input-date-end'
                                                    : 'input-datetime-end'
                                            "
                                            [attr.required]="
                                                formElement.isRequired
                                            "
                                            [wdxUtilsDisabled]="
                                                isDisabled ||
                                                PENDING_CHANGES_LOCK_FIELD.includes(
                                                    $any(
                                                        formElement
                                                            .pendingChange
                                                            ?.status
                                                    )
                                                )
                                            "
                                            (blur)="dateBlurEvent('end')"
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </wdx-form-field>
        }
    </ng-container>
}
